module.exports = __webpack_public_path__ + "media/assets/images/Card_1-d3ef78d8193530ce7ee848d84acabd9a.png";